import { oc } from '@orpc/contract';
import { updateVehicleInputSchema, vehicleSchema } from '../schemas/vehicles.schemas.js';
export const updateVehicleContract = oc
    .route({
    method: 'PATCH',
    path: '/vehicles/{id}',
    tags: ['Vehicles'],
    summary: 'Update a vehicle specification',
    description: 'MANAGER only. Only the supplied fields change; an explicit null clears a field.',
})
    .input(updateVehicleInputSchema)
    .output(vehicleSchema);
//# sourceMappingURL=update-vehicle.contract.js.map